import { render, staticRenderFns } from "./delFailDialog.vue?vue&type=template&id=56ffcc5f&scoped=true&"
import script from "./delFailDialog.vue?vue&type=script&lang=js&"
export * from "./delFailDialog.vue?vue&type=script&lang=js&"
import style0 from "./delFailDialog.vue?vue&type=style&index=0&id=56ffcc5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ffcc5f",
  null
  
)

export default component.exports